import "./InvoicePage.css";
import { Link } from "wouter-preact";
import { ErrorPanel, LoadingPanel } from "../components/StatePanels";
import { InvoiceContent } from "../features/invoices/InvoiceContent";
import { routes } from "../lib/route";
import { useInvoicePage } from "./useInvoicePage";

export function InvoicePage({ invoiceCode }: { invoiceCode: string }) {
  const page = useInvoicePage(invoiceCode);
  return (
    <div class="portal-invoice">
      <nav aria-label="Invoice navigation">
        <Link href={`~${routes.portal.overview()}`} className="link-action">
          Back to overview
        </Link>
      </nav>
      {page.status === "notFound" ? (
        <ErrorPanel title="Invoice not found" message={page.message} />
      ) : page.status === "error" ? (
        <ErrorPanel title="Unable to load invoice" message={page.message} onRetry={page.retry} />
      ) : page.status === "loading" ? (
        <LoadingPanel title="Loading invoice" />
      ) : (
        <InvoiceContent page={page} />
      )}
    </div>
  );
}
